import Flickity from "flickity";
require('flickity-as-nav-for');
require('flickity-fade');
require('flickity-imagesloaded');

export default class Carousel {

    constructor(elem, options) {
        this.throttle = null;
        this.carousel = new Flickity(elem, options);
        window.addEventListener('resize', event => this.resize(this.carousel, this.throttle));
    }
    resize(carousel, throttle) {
        if (!throttle) {
            throttle = setTimeout(function () {

                carousel.resize();
                document.querySelector('.flickity-viewport').style.height = null;
                throttle = null;
            }, 100);
        }
    }

}